/**
 * Time dimension constants used across myTarget Performance
 */
export const TIME_DIMENSIONS = {
    PRIOR_DAY: 'Prior Day',
    WEEK_TO_DAY: 'Week to Day',
    PRIOR_WEEK: 'Prior Week',
    LAST_4_WEEKS: 'Last 4 Weeks',
    MONTH_TO_DAY: 'Month to Day',
    MONTH_TO_WEEK: 'Month to Week',
    PRIOR_MONTH: 'Prior Month',
    QUARTER_TO_WEEK: 'Quarter to Week',
    PRIOR_QUARTER: 'Prior Quarter',
    YEAR_TO_DAY: 'Year to Day',
    YEAR_TO_WEEK: 'Year to Week',
    PRIOR_YEAR: 'Prior Year',
} as const

/**
 * Time dimensions used in detail views (Greenfield format)
 */
export const DETAIL_TIME_DIMENSIONS = ['last_week', 'year_to_week'] as const
